'use strict';

/**
 *
 * @name: nownessApp.translations
 *
 */

import translationsLoaderConfig from './nn-translations-loader.config';
import translationsLoaderRun from './nn-translations-loader.run';
import translationsLoaderFactory from './nn-translations-loader.factory';
import translateDateFactory from './nn-translate-date.factory';

const TranslationsModule = angular
  .module('nownessApp.translations', [])
  .config(translationsLoaderConfig)
  .run(translationsLoaderRun)
  .factory('translationsLoader', translationsLoaderFactory)
  .factory('translateDate', translateDateFactory);

export default TranslationsModule.name;



// WEBPACK FOOTER //
// ./app/components/nn-translations/nn-translations.module.js